import { keepPreviousData } from "@tanstack/query-core";
import { FRAMEWORKS_SUGGESTIONS_LIMIT } from "PFApp/constants/activity_form/skills_frameworks_limits";
import { useSkillsFrameworksOptions } from "PFCore/hooks/queries/skills_frameworks/use_skills_frameworks_options";
import { ActivityCustomField, SkillsFramework, SkillsFrameworkRank } from "PFCore/types";

type UseSkillsFrameworksSuggestionsArgs = {
  customFields?: ActivityCustomField[];
  isEnabled?: boolean;
  rank?: SkillsFrameworkRank;
  recommendationTerm: string;
};

export const useSkillsFrameworksSuggestions = ({
  recommendationTerm,
  customFields,
  isEnabled,
  rank
}: UseSkillsFrameworksSuggestionsArgs) => {
  const { data: skillsFrameworks, isFetching: isSkillsFrameworksSuggestionsFetching } =
    useSkillsFrameworksOptions(
      { customFields, perPage: FRAMEWORKS_SUGGESTIONS_LIMIT, rank, recommendationTerm },
      {
        enabled: isEnabled,
        placeholderData: isEnabled ? keepPreviousData : undefined
      }
    );

  return {
    skillsFrameworksSuggestions: (skillsFrameworks?.entries || []) as SkillsFramework[],
    isSkillsFrameworksSuggestionsFetching
  };
};
